import { render, staticRenderFns } from "./QuickTipsSchedule.vue?vue&type=template&id=6a2281bc&scoped=true&"
import script from "./QuickTipsSchedule.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2281bc",
  null
  
)

export default component.exports